export class TakenHours {
  taken_hours: number = 0
  adi_hours: number = 0
  remaining_hours: number = 0
  percentage_used: number = 0
  hasAcceptedLessons: boolean = false
}
